var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<tr class=\"adding-phrase\" data-id=\""
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"_cid") : depth0), depth0))
    + "\">\n    <td colspan=\"3\">\n        <div class=\"inner\">\n            <span class=\"spinner\"></span>\n            <div class=\"q\">"
    + alias1(__default(require("../../helpers/renderPhrase.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"query") : depth0),{"name":"renderPhrase","hash":{},"data":data,"loc":{"start":{"line":5,"column":27},"end":{"line":5,"column":49}}}))
    + "</div>\n        </div>\n    </td>\n    <td></td>\n    <td></td>\n    <td></td>\n</tr>\n";
},"useData":true});